import * as React from 'react';

import {Button} from 'shells/button/button';

import type {
    SmsDripSequenceFragment as DripSequence,
    SmsDripEditionFragment as Edition,
} from 'nutshell-graphql-types';

import {ActivateDripSequenceModal} from '../../../drip-sequences/drip-sequence-page/activate-sequence-modal/activate-drip-sequence-modal';

import {useGetSessionUser} from '../../../../core/use-get-session-user';

import {useActivateSmsDripSequence} from '../graphql/hooks/use-activate-sms-drip-sequence';

type Props = {
    isDisabled: boolean;
    dripSequence: DripSequence;
    editions: Edition[];
};

export function ActivateSequenceButton(props: Props) {
    const [isActivatingSequence, setIsActivatingSequence] = React.useState<boolean>(false);

    const {user} = useGetSessionUser();
    const {activateSmsDripSequence} = useActivateSmsDripSequence();

    return (
        <>
            <Button
                disabled={props.isDisabled}
                variant='primary'
                size='big'
                onClick={() => {
                    setIsActivatingSequence(true);
                }}
            >
                Activate sequence
            </Button>
            {isActivatingSequence && (
                <ActivateDripSequenceModal
                    dripSequence={props.dripSequence}
                    editions={props.editions}
                    isOpen={isActivatingSequence}
                    canAccessSetup={Boolean(user && user.permissions.canAccessSetup)}
                    onCloseModal={() => setIsActivatingSequence(false)}
                    onConfirmActivate={() => {
                        setIsActivatingSequence(false);

                        return activateSmsDripSequence({dripSequenceId: props.dripSequence.id});
                    }}
                    isLoading={false}
                    scrollToEdition={(editionId: string) => {
                        const edition = document.getElementById(editionId);
                        if (edition) {
                            edition.scrollIntoView();
                        }
                    }}
                />
            )}
        </>
    );
}
